import {
  React,
  Component
} from 'imports/CommonImports';

import {StageBox} from 'imports/ComponentsImports';

const styles = {
  pageContainer: {
    display: 'flex',
    padding: '0 1.5em',
    flexWrap: 'wrap',
  },
  boxContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
    width: '100%',
  },
  infoContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '2em',
    flexDirection: 'column',
  },
  box: {
    margin: '1em',
    minWidth: '14em',
    maxWidth: '24em',
    flex: '1',
  }
}
class Stages extends Component {

  render() {
    let user = this.props.user;
    let stage = this.props.currentStage;
    return (
      <div style={styles.pageContainer}>
        <div style={styles.infoContainer}>
          <h1>Hola {user.first_name} {user.last_name} !</h1>
          <p> Bienvenido a tu portal i3.  Estas son las tres etapas que deberás completar para obtener tu indicador de intensidad de innovación. </p>
        </div>
        <div style={styles.boxContainer}>
          {/* Criteria */}
          <StageBox
            pending={['PC', 'CC'].includes(stage.name)}
            active={['PC', 'CC', 'SP', 'PO'].includes(stage.name)}
            header={'1. Criterios'}
            info='Revisa aquí los criterios base de innovación que han sido fijados para tu empresa.'
            pendingInfo='Aún no comienzas con el proceso i3 de tu empresa.'
            buttonAction={() => this.props.history.push('manager_criteria')}
            style={styles.box}
            />
          {/* Proyects porftolio */}
          <StageBox
            pending={['PC', 'CC', 'SP', 'PO', 'SI', 'SE', 'WS', 'FI', 'PF'].includes(stage.name)}
            active={['SP', 'PO', 'SI', 'SE', 'WS', 'FI', 'PF'].includes(stage.name)}
            header={'2. Portafolio'}
            info='Define los proyectos que serán parte del portafolio de innovación y calcula su aporte económico a la empresa.'
            pendingInfo='Aún no están definidas tus convenciones base. Deberás completar la etapa 1 para comenzar con el portafolio de innovación.'
            buttonAction={() => this.props.history.push('portfolio')}
            style={styles.box}
            />
          {/* Dashboard */}
          <StageBox
            pending={stage.name !== 'DB'}
            active={['PT', 'DB'].includes(stage.name)}
            header={'3. Metas'}
            info='Revisa aquí tu índice i3 y define las metas de innovación para tu empresa'
            pendingInfo='Para ver los indicadores de innovación de tu empresa deberás completar la sección convenciones base y portafolio de innovación'
            buttonAction={() => this.props.history.push('dashboard/summary')}
            style={styles.box}
            />
        </div>
      </div>
    );
  }
}

export default Stages;



// WEBPACK FOOTER //
// ./src/components/common/Stages.js